export enum SnackbarType {
  error = 0,
  success = 1,
  warning = 2,
}

export const SnackbarText: any[] = [
  {
    name: 'Error',
    className: 'error',
  },
  {
    name: 'Success',
    className: 'success',
  },
  {
    name: 'Warning',
    className: 'warning',
  },
];
